// @flow
import EventEmitter from 'events';
import Dispatcher from 'dispatcher';
import * as ActionTypes from 'action_types/ScreeningParamsActionTypes';
import ScreeningParam from 'models/ScreeningParams';

const CHANGE = 'change';
let _listScreeningParams = [];

class ScreeningParamsStore extends EventEmitter {
  constructor() {
    super();
    Dispatcher.register(this._handlerActions);
  }

  getScreeningParam = (keyParam: string) => {
    return _listScreeningParams[keyParam] || [];
  };

  setScreeningParams = (
    keyParam,
    listScreeningParams: Array<ScreeningParam>
  ) => {
    _listScreeningParams[keyParam] = listScreeningParams;
  };

  _emitChange = () => {
    this.emit(CHANGE);
  };

  addChangeListener = (callback: () => void): void => {
    this.on(CHANGE, callback);
  };

  removeChangeListener = (callback: () => void): void => {
    this.removeListener(CHANGE, callback);
  };

  _handlerActions = (action: any) => {
    switch (action.type) {
      case ActionTypes.LIST_SCREENING_PARAMS: {
        this.setScreeningParams(action.keyParam, action.listScreeningParams);
        this._emitChange();
      }
    }
  };
}

export default new ScreeningParamsStore();
